<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';

import { acaoConcluidaNaSessao } from '@/composables/convite-pesquisa';
import { PesquisaSatisfacaoService } from '@/services/pesquisa-satisfacao.service';

const router = useRouter();

const visivel = ref(false);
const decidindo = ref(false);
let jaOferecidoNaSessao = false;

const avaliar = () => {
  visivel.value = false;
  router.push({ name: 'PesquisaSatisfacao' });
};

const adiar = async () => {
  decidindo.value = true;
  try {
    await PesquisaSatisfacaoService.adiar();
  } catch {
    visivel.value = false;
  } finally {
    decidindo.value = false;
    visivel.value = false;
  }
};

watch(acaoConcluidaNaSessao, async (concluiu) => {
  if (!concluiu || jaOferecidoNaSessao) return;
  jaOferecidoNaSessao = true;

  try {
    const { elegivel } = await PesquisaSatisfacaoService.verificarElegibilidade();
    visivel.value = elegivel;
  } catch {
    visivel.value = false;
  }
});
</script>

<template>
  <aside v-if="visivel" class="convite-pesquisa" role="complementary" aria-label="Convite para avaliar o C-Conecte">
    <p class="convite-pesquisa__titulo">Como está sendo usar o C-Conecte?</p>
    <p class="convite-pesquisa__texto">São 5 minutos e ajuda a melhorar o portal.</p>

    <div class="convite-pesquisa__acoes">
      <Button label="Agora não" severity="secondary" text size="small" :disabled="decidindo" @click="adiar" />
      <Button label="Avaliar" icon="pi pi-star" size="small" :loading="decidindo" @click="avaliar" />
    </div>
  </aside>
</template>

<style scoped>
.convite-pesquisa {
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 1100;
  width: min(22rem, calc(100vw - 3rem));
  padding: 1rem 1.25rem;
  border: 1px solid var(--c-border);
  border-left: 4px solid var(--c-primary-500);
  border-radius: 8px;
  background-color: var(--c-surface);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
}

.convite-pesquisa__titulo {
  margin: 0 0 0.25rem;
  font-weight: 600;
}

.convite-pesquisa__texto {
  margin: 0 0 1rem;
  font-size: var(--c-text-sm);
  color: var(--c-text-muted);
}

.convite-pesquisa__acoes {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
</style>
